import PropTypes from 'prop-types'
import { useState } from 'react'

/**
 * DateRangePicker - Simple date range picker
 */
export default function DateRangePicker({ startDate, endDate, onChange }) {
  const [localStart, setLocalStart] = useState(startDate?.substring(0, 10) || '')
  const [localEnd, setLocalEnd] = useState(endDate?.substring(0, 10) || '')

  const handleApply = () => {
    if (localStart && localEnd) {
      onChange(localStart, localEnd)
    }
  }

  return (
    <div className="flex items-center gap-2">
      <input
        type="date"
        value={localStart}
        onChange={(e) => setLocalStart(e.target.value)}
        className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent"
      />
      <span className="text-gray-500">à</span>
      <input
        type="date"
        value={localEnd}
        onChange={(e) => setLocalEnd(e.target.value)}
        className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent"
      />
      <button
        onClick={handleApply}
        className="px-4 py-2 bg-primary-600 text-white rounded-lg text-sm font-medium hover:bg-primary-700 transition-colors"
      >
        Appliquer
      </button>
    </div>
  )
}

DateRangePicker.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  onChange: PropTypes.func.isRequired
}
